<template>  
  <v-container>
    <v-snackbar
      v-model="snackbar"
      :color="color"
      top
    >
      {{text}}
      <v-btn text  @click.native="snackbar = false">Close</v-btn>
    </v-snackbar>
    <v-row justify="center">
        <v-col cols="12" xs="12" sm="8" md="7" lg="6" class="my-5">
          <v-card class="elevation-0" align="center">
            <v-card-title primary-title class="primary--text">
              Registrarse
              <v-spacer></v-spacer>
              <v-btn  text  :to="{name: 'login'}"><v-icon>reply</v-icon></v-btn>
            </v-card-title>
            <v-img
              :src="logo"
              content
              width="250"
            ></v-img>
            <v-card-text>
              <v-form
                ref="form"
                v-model="valid"
                :lazy-validation="lazy"
              >
                
                <v-text-field
                  v-model="nomper"
                  :counter="50"
                  :rules="nameRules"
                  label="Nombre"
                  required
                ></v-text-field>

                <v-text-field
                  v-model="email"
                  :rules="emailRules"
                  label="E-mail"
                  required
                ></v-text-field>

                <v-text-field
                  v-model="password"
                  prepend-icon="lock"
                  :append-icon="show1 ? 'visibility' : 'visibility_off'"
                  :rules="rulesPassword"
                  :type="show1 ? 'text' : 'password'"
                  label="contraseña"
                  hint="At least 8 characters"
                  counter
                  @click:append="show1 = !show1"
                ></v-text-field>

                <v-text-field
                  v-model="password2"
                  prepend-icon="lock"
                  :append-icon="show ? 'visibility' : 'visibility_off'"
                  :rules="rulesPassword2"
                  :type="show ? 'text' : 'password'"
                  label="contraseña"
                  hint="At least 8 characters"
                  counter
                  @click:append="show = !show"
                ></v-text-field>

              </v-form>
            </v-card-text>   

            <v-card-actions>
              <v-btn
                :disabled="!valid"
                color="success"
                class="mr-4"
                @click="validarExistencia"
              >
                Aceptar
              </v-btn>      
              <v-spacer></v-spacer>
              <v-btn
                color="primary"
                class="mr-4"
                :to="{name:'login'}"
              >
                Regresar
              </v-btn>
            </v-card-actions>    
          </v-card>
        </v-col>
      </v-row>
  </v-container>
</template>


<script>

  import {mapActions , mapGetters} from 'vuex'

  var accounting = require("accounting");
  var md5     = require('md5')

  export default {
    
    data () {
      return {
        valid: true,
        nomper: '',
        nameRules: [
          v => !!v || 'Nombre es requerido',
          v => (v && v.length <= 50) || 'Máximon 50 caracteres',
        ],
        email: '',
        emailRules: [
          v => !!v || 'E-mail es requerido',
          v => /.+@.+\..+/.test(v) || 'E-mail no es valido',
        ],

        lazy: false,

        // PASSWORD
        show1: false,
        show: false,
        password:'',
        password2:'',
        rulesPassword: [
          v => !!v || 'Requerido.',
          v => v.length >= 8 || 'Minímo 8 caracteres',
        ],
        rulesPassword2: [
          v => !!v || 'Requerido.',
          v => v.length >= 8 || 'Minímo 8 caracteres',
          v => v == this.password || 'Las contraseñas no coinciden',
        ],
        // SNACKBAR
        snackbar: false,
        logo:'',
        text:'',
        color:''

      }
    },

    created () {
      this.$http.get('config.list').then(response=>{
        var ciaws = response.body
        this.logo = this.$http.options.root + 'fotos/' + ciaws.logourl
      }, error => {
        console.log(error)
      })
    },

    methods:{

      validarExistencia(){
        var payload = {
          nomuser  : '',
          nomper   : this.nomper,
          email    : this.email,
          password : md5(this.password),
          nivel    : 'USER',
          estatus  : 0
        }

        this.$http.post('user.email', payload).then(respuesta=>{
          console.log('respuesta getId',respuesta)
          if(respuesta.body.message){
            this.newUsuario(payload)
          }else{
            console.log('no agregar')
            if(respuesta.body.email == this.email){
              this.text = 'El correo que quieres registrar ya existe'
              this.color = 'red'
              this.snackbar = true
            }
          }
        })
      },

      newUsuario(payload){
        this.$http.post('user.add', payload).then( response => {
          this.enviarCorreo(response.body.id)
          this.snackbar = true
          this.color = "blue lighten-3"
          this.text = "El usuario se guardo correctamente."
        }).catch(error => {
          console.log(error.body)
        })
      },

      enviarCorreo(id){
        var url = this.$http.options.root.substr(0,this.$http.options.root.length -6) + '/admin-app/#/activarusuario/'

        var payload = {
          nomper:       this.nomper,
          correo:       this.email,
          url:          url + id
        }

        this.$http.post('correos.send',  payload).then(respuesta=>{ 
          console.log(respuesta)
          this.text = 'Se envío un correo de validación'
          this.color = 'success'
          this.snackbar = true
        }).catch(error=>{
          console.log('error',error)
          resolve(false)
        })
      },

    }
  };
</script>




